import React from 'react';
import './Presentacion.css';

const resolucion862 = require("../documents/resolucion 862 .pdf");
const resolucion609 = require("../documents/Resol.609 Lineas de Ribera.pdf");

const formularios = [
  {
    categoria: 'Constancia de Factibilidad de Mitigacion de Riesgos contra Inundaciones - ',
    resolucion: {
      texto: '(Resolucion 862 y complementarias)',
      archivo: resolucion862
    },
    items: [
      {
        codigo: 'A1-1',
        titulo: 'Prefactibilidad de Mitigacion de Riesgos contra Inundaciones',
        descripcion: 'Formulario para Prefactibilidad de Mitigacion de Riesgos contra Inundaciones',
        archivo: require("../documents/Formulario tipo-A 1-1.pdf")
      },
      {
        codigo: 'A1-2',
        titulo: 'Propuesta de Manejo de Aguas (Anteproyecto de Desagues Pluviales)',
        descripcion: 'Formulario para Propuesta de Manejo de Aguas (Anteproyecto de Desagues Pluviales)',
        archivo: require("../documents/Formulario tipo-A 1-2.pdf")
      },
      {
        codigo: 'A1-3',
        titulo: 'Propuesta de Manejo de Aguas (Proyecto Ejecutivo de Desagues Pluviales)',
        descripcion: 'Formulario para Propuesta de Manejo de Aguas (Proyecto Ejecutivo de Desagues Pluviales)',
        archivo: require("../documents/Formulario tipo-A 1-3.pdf")
      },
      {
        codigo: 'A1-3A',
        titulo: 'Ampliacion de Validez del Proyecto ejecutivo de desagues',
        descripcion: 'Formulario para Ampliacion de Validez del Proyecto Ejecutivo de Desagues',
        archivo: require("../documents/Formulario tipo-A 1-3A.pdf")
      },
      {
        codigo: 'A1-4',
        titulo: 'Inicio de Ejecucion y solicitud de Inspeccion',
        descripcion: 'Formulario para Inicio de Ejecucion y solicitud de Inspeccion',
        archivo: require("../documents/Formulario tipo-A 1-4.pdf")
      },
      {
        codigo: 'A1-5',
        titulo: 'Aceptacion Tecnica Definitiva de Obras (CFMRCI)',
        descripcion: 'Formulario para Aceptacion Tecnica Definitiva de Obras (CFMRCI)',
        archivo: require("../documents/Formulario tipo-A 1-5.pdf")
      }
    ]
  },
  {
    categoria: 'Aceptacion Tecnica de Obras en Cauces (ATO)',
    resolucion: {
      texto: ' - (Resolucion 862 - Anexo II)',
      archivo: resolucion862
    },
    items: [
      {
        codigo: 'A2-1',
        titulo: 'Aceptacion de la Propuesta de Obras Anteproyecto',
        descripcion: 'Formulario para Aceptacion de la Propuesta de Obras Anteproyecto',
        archivo: require("../documents/Formulario tipo-A 2-1.pdf")
      },
      {
        codigo: 'A2-2',
        titulo: 'Aceptacion del Proyecto Ejecutivo de Obras',
        descripcion: 'Formulario para Aceptacion del Proyecto Ejecutivo de Obras',
        archivo: require("../documents/Formulario tipo-A 2-2.pdf")
      }
    ]
  },
  {
    categoria: 'Lineas de Riberas / Terrenos lindantes con Rios, Canales, Diques - ',
    resolucion: {
      texto: '(Resolucion 609)',
      archivo: resolucion609
    },
    items: [
      {
        codigo: 'A3-1',
        titulo: 'Presentacion de la propuesta',
        descripcion: 'Formulario para Presentacion de la propuesta de Lineas de Riberas',
        archivo: require("../documents/Res. linea ribera.pdf")
      }
    ]
  }
];

const Presentacion = () => {
  return (
    <main className="presentacion-page">
      <section className="presentacion-hero">
        <div className="presentacion-shell reveal-on-scroll">
          <h1>Presentacion de Documentacion</h1>
          <p>
            Acceso a formularios oficiales y lineamientos para la presentacion de tramites ante la
            Direccion Provincial del Agua.
          </p>
        </div>
      </section>

      <section className="presentacion-content">
        <div className="presentacion-shell presentacion-grid">
          <article className="presentacion-card reveal-on-scroll">
            <h2>Atencion a Profesionales y Desarrolladores</h2>
            <div className="presentacion-info-box">
              <p><strong>Martes y Jueves de 08:00 a 13:00Hs</strong></p>
              <p>
                En esta pagina encontrara los formularios para la presentacion de documentacion a la
                reparticion. Cada tramite tiene un formulario el cual debe llenar y adjuntar a la
                documentacion requerida para el mismo.
              </p>
            </div>
          </article>

          <article className="presentacion-card reveal-on-scroll">
            <h2>Instrucciones de Presentacion</h2>
            <div className="presentacion-info-box">
              <p>
                Toda la documentacion debe ser presentada digitalmente a traves de nuestro mail:
                <a href="mailto:mesadeentradas@dpatuc.com"> mesadeentradas@dpatuc.com</a>
              </p>
              <p>
                Una vez presentada recibira un mail con la confirmacion de la recepcion y el numero de
                expediente con el cual podra darle seguimiento en: 
                <a
                  href="https://sitiosigedoc.tucuman.gov.ar/consultas/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SiGeDoc | Consulta de expedientes
                </a>
              </p>
            </div>
          </article>
        </div>

        <div className="presentacion-shell presentacion-section reveal-on-scroll">
          <h2>Tramites</h2>
          {formularios.map((categoria) => (
            <div className="presentacion-categoria" key={categoria.categoria}>
              <h3>
                {categoria.categoria}
                {categoria.resolucion ? (
                  <a href={categoria.resolucion.archivo} download>
                    {categoria.resolucion.texto}
                  </a>
                ) : null}
              </h3>
              <ul>
                {categoria.items.map((item) => (
                  <li key={item.codigo}>
                    <a href={item.archivo} download title={item.descripcion}>
                      {item.codigo} - {item.titulo}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Presentacion;
